export default __webpack_public_path__ + "static/media/menu-top1x.93fe298f.png";